import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.6667 4.33073C10.6667 5.80349 9.47275 6.9974 7.99999 6.9974C6.52723 6.9974 5.33332 5.80349 5.33332 4.33073C5.33332 2.85797 6.52723 1.66406 7.99999 1.66406C9.47275 1.66406 10.6667 2.85797 10.6667 4.33073Z",
      stroke: "currentColor",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.99999 8.33073C5.26433 8.33073 3.27753 10.3058 2.76741 12.9433C2.69312 13.3274 3.00319 13.6641 3.39438 13.6641H12.6056C12.9968 13.6641 13.3069 13.3274 13.2326 12.9433C12.7224 10.3058 10.7356 8.33073 7.99999 8.33073Z",
      stroke: "currentColor",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }